// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CopyPartRevisionBomApi {
	export async function copyRevisionBom(args: {
		targetPartRevisionId: number;
		sourcePartRevisionId: number;
		copyOperations: boolean;
		copyConfiguratorPriceScript: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/partRevisionBom/copyRevisionBom",
			method: "POST",
			data: {
				targetPartRevisionId: args.targetPartRevisionId,
				sourcePartRevisionId: args.sourcePartRevisionId,
				copyOperations: args.copyOperations,
				copyConfiguratorPriceScript: args.copyConfiguratorPriceScript,
			},
		});
		return response as void;
	}
}
